module.exports = __webpack_public_path__ + "img/Avatar-87.32d3c0b9.svg";